define(function(require) {
    const Cell = require('../BaseCell');
    const _ = require('underscore');

    /**
     * Renders the cell as text
     * @param {Object} options
     * @returns column definition
     */
    const TextCell = function(options) {
        return {
            CellClass: Cell,

            options: _.extend(
                {
                    className: 'dt-body-left text-left',
                    iconTitle: undefined,
                    iconClass: undefined,
                    asHtml: false,
                    showTooltip: true,
                    onDisplay: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        const iconTitle = _.isFunction(this.iconTitle) ? this.iconTitle(row) : this.iconTitle;

                        let tooltip = '';
                        if (this.showTooltip) {
                            if (this.cellTooltip) {
                                if (_.isFunction(this.cellTooltip)) {
                                    tooltip = this.cellTooltip(data, row);
                                } else {
                                    tooltip = this.cellTooltip;
                                }
                            } else {
                                tooltip = translatedValue;
                            }
                        }

                        return _.template(/* template */ `<div data-toggle="tooltip" 
                                                        title="<%- tooltip %>" 
                                                        class="data-grid__cell--text">
                                                        <%= data %>
                                                        <% if (iconClass && iconClass.length > 0 && iconTitle && iconTitle.length > 0) { %>
                                                        <i class="<%- iconClass %>" title="<%- iconTitle%>"/>
                                                        <% } %>
                                                    <div>`)({
                            data: this.asHtml ? translatedValue : _.escape(translatedValue),
                            iconTitle: iconTitle,
                            iconClass: this.iconClass,
                            tooltip: tooltip
                            // Show a tooltip if it might be truncated
                            // tooltip: translatedValue && translatedValue.length > 50 ? translatedValue : ''
                        });
                    },
                    onExport: function(data, type, row, meta, translatedValue) {
                        return translatedValue;
                    }
                },
                options
            )
        };
    };
    return TextCell;
});
